// useForm.tsx
import { useRef, useCallback } from 'react';
import { FormRef } from 'src/components';

export const useForm = () => {
  const formRef = useRef<FormRef & { scrollIntoView?: () => void }>(null);

  const getValues = useCallback(() => formRef.current ? formRef.current.getValues() : {}
    , []);

  const setFieldValue = useCallback((fieldName: string, value: any, validation?: boolean) => {
    if (formRef.current) {
      formRef.current.setFieldValue(fieldName, value, validation);
    }
  }, []);

  const submitForm = useCallback(() => {
    if (formRef.current) {
      formRef.current.submitForm();
    }
  }, []);

  const validateForm = useCallback((validateFields?: string[]) => {
    if (formRef.current) {
      return formRef.current.validateForm(validateFields);
    }
    return false;
  }, []);

  const scrollIntoView = useCallback(() => {
    if (formRef.current?.scrollIntoView) {
      formRef.current.scrollIntoView();
    }
  }, []);

  return { formRef, getValues, setFieldValue, submitForm, validateForm, scrollIntoView };
};